<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import EventShow from 'dashboard/routes/dashboard/planning/events/Show.vue';

const route = useRoute();
const eventId = computed(() => route.params.id);
</script>

<template>
  <EventShow :event-id="eventId" />
</template>
